import * as React from "react";
import type { SVGProps } from "react";
const SvgVisaBlock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 35 25"
    {...props}
  >
    <rect
      width={34}
      height={23}
      x={0.5}
      y={0.518}
      fill="#fff"
      stroke="#D9D9D9"
      rx={3.5}
    />
    <path
      fill="#172B85"
      fillRule="evenodd"
      d="M10.625 16.276h-2.12l-1.59-6.066c-.076-.28-.236-.526-.471-.642A6.9 6.9 0 0 0 4.5 8.926v-.234h3.416a.89.89 0 0 1 .884.759l.825 4.375 2.119-5.134h2.061zm4.359 0H12.98l1.65-7.584h2.002zm4.24-5.483c.058-.408.412-.642.824-.642a3.73 3.73 0 0 1 1.944.35l.353-1.633a5.1 5.1 0 0 0-1.825-.35c-1.944 0-3.358 1.05-3.358 2.508 0 1.109 1.002 1.691 1.709 2.042.765.35 1.06.583 1 .933 0 .525-.589.758-1.177.758a5.05 5.05 0 0 1-2.061-.467l-.354 1.634a5.8 5.8 0 0 0 2.18.408c2.179.058 3.533-.991 3.533-2.566 0-1.984-2.769-2.1-2.769-2.975M29 16.276l-1.59-7.584h-1.708a.89.89 0 0 0-.825.584l-2.944 7h2.061l.412-1.108h2.533l.235 1.108zm-3.003-5.541.588 2.858h-1.649z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgVisaBlock;
